module.exports = __webpack_public_path__ + "static/11-811f31e4cc8f2837fbb6d70bab2458c6.jpg";